<template>
  <ModalDefault modal_id="historyTicketModal"
                header="y"
                size="modal-lg modal-dialog-scrollable"
                style_header=""
                :modal_header="getTranslations('expression_707')"
                footer="y"
                icon="bx bx-history mr-1">
    <div class="px-2 py-2 pb-3" slot="body">
      <div class="row" style="max-height: 480px; min-height: 480px; ">
        <div v-if="!chat.ui.ticket_history" class="col-12 px-4 pt-3 pb-3">
          <div v-if="chat.old_tickets.total > 0" class="table-responsive card shadow-sm">
            <table class="table">
              <thead class="bg-light">
              <tr class="text-center py-3">
                <th scope="col" class="border-top-0 py-3" style="min-width: 120px;">
                  <small>{{ getTranslations('expression_48') }}</small>
                </th>
                <th scope="col" class="border-top-0 py-3" style="min-width: 120px;">
                  <small>{{ getTranslations('expression_12') }}</small>
                </th>
                <th scope="col" class="border-top-0 py-3" style="min-width: 120px;">
                  <small>{{ getTranslations('expression_72') }}</small>
                </th>
                <th scope="col" class="border-top-0 py-3" style="min-width: 120px;">
                  <small>{{ getTranslations('expression_708') }}</small>
                </th>
                <th scope="col" class="border-top-0 py-3" style="min-width: 120px;">
                  <small>{{ getTranslations('expression_67') }}</small>
                </th>
              </tr>
              </thead>
              <tbody>
              <!-- @click.prevent="chat.ui.ticket_history = !chat.ui.ticket_history;
              showOldHistories(ticket)"-->
              <tr v-for="ticket in chat.old_tickets.data" :key="ticket.id"
                  @click.prevent="showHistories(ticket)"
                  data-toggle="modal" data-target="#showTicketModal"
                  class="text-center tab_hover title-color-hover cursor_pointer">
                <td class="ellipsis align-middle py-3" style="max-width: 120px;">
                  <div class="d-flex ellipsis">
                    <span v-b-tooltip.right :title="getUserObject('id', getOperatorObject('id', ticket.operator_id).user_id).name ? getUserObject('id', getOperatorObject('id', ticket.operator_id).user_id).name : '---'"
                          class="pl-1 w-100 ellipsis">
                      {{ getUserObject('id', getOperatorObject('id', ticket.operator_id).user_id).name ? getUserObject('id', getOperatorObject('id', ticket.operator_id).user_id).name : '---' }}
                    </span>
                  </div>
                </td>
                <td class="ellipsis align-middle py-3" style="max-width: 120px;">
                  <div class="d-flex ellipsis">
                    <span v-b-tooltip.right :title="getDepartmentObject('id', ticket.department_id).name ? getDepartmentObject('id', ticket.department_id).name : '---'"
                          class="pl-1 w-100 ellipsis">
                      {{ getDepartmentObject('id', ticket.department_id).name ? getDepartmentObject('id', ticket.department_id).name : '---' }}
                    </span>
                  </div>
                </td>
                <td class="ellipsis align-middle py-3" style="max-width: 120px;">
                  <div class="d-flex ellipsis">
                    <span v-b-tooltip.right :title="ticket.protocol ? ticket.protocol : '---'"
                          class="pl-1 w-100 ellipsis">
                      {{ ticket.protocol ? ticket.protocol : '---' }}
                    </span>
                  </div>
                </td>
                <td class="ellipsis align-middle py-3" style="max-width: 120px;">
                  <div class="d-flex ellipsis">
                    <span v-b-tooltip.right :title="ticket.created"
                          class="pl-1 w-100 ellipsis">
                      {{ ticket.created }}
                    </span>
                  </div>
                </td>
                <td class="ellipsis align-middle py-3" style="max-width: 120px;">
                  <div class="d-flex ellipsis">
                    <span v-b-tooltip.right :title="ticket.status ? ticket.status.status : '---'"
                          class="pl-1 w-100 ellipsis">
                      <small :class="`bg-${ticket.status.label}`" class="ellipsis badge rounded-0 font-weight-light py-1 px-2 text-white"> {{ ticket.status ? ticket.status.status : '---' }} </small>
                    </span>
                  </div>
                </td>
              </tr>
              </tbody>
            </table>
          </div>
          <div v-else class="row">
            <div class="col-12 d-flex "
                 style="justify-content: center;
                     align-items: center;
                     min-height: 480px;">
              <div class="col-12 py-0 px-4 text-center">
                <div class="pt-4 pb-4">
                  <div class="pt-3">
                    <i class="fas fa-inbox fa-3x pb-3 text-gray-300"></i>
                  </div>
                  <div class="pb-4">{{ getTranslations('expression_709') }}</div>
                </div>
              </div>
            </div>
          </div>
          <div v-if="!chat.ui.ticket_history && chat.old_tickets.total > 0" class="animated--fade-in row text-center pt-4 pb-0" style="justify-content: center">
            <div class="col-12 pt-1 pb-2">
              <small class="">
                {{ chat.old_tickets.total > 1
                  ? `${chat.old_tickets.total} ${getTranslations('expression_116')}`
                  : `${chat.old_tickets.total} ${getTranslations('expression_117')}` }}
              </small>
            </div>
            <Pagination class=" mb-4"
                        page_item="background-color: #ffffff!important; border-color: #ffffff!important;"
                        page_link="background-color: #ffffff!important; border-color: #ffffff!important;"
                        :items="chat.old_tickets"
                        commit="SET_OLD_TICKETS">
            </Pagination>
          </div>
        </div>
        <div v-else class="col-12 px-3 pb-5">
          <div v-if="chat.old_histories.length > 0" style="max-height: 400px;" id="chat_conversation1" class="pb-3 animated--grow-in chat_conversation">
            <ChatBalloonDefault :history="history" v-for="history in chat.old_histories" :key="history.id"/>
            <div class="pt-3">&nbsp;</div>
          </div>
          <div v-else class="row">
            <div class="col-12 d-flex "
                 style="justify-content: center;
                    align-items: center;
                    min-height: 480px;">
              <div class="spinner-border text-info"
                   style="width: 3rem; height: 3rem;"
                   role="status">
                <span class="sr-only">{{ getTranslations('expression_36') }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div slot="footer" class="px-2 py-2 d-flex">
      <div v-if="chat.ui.ticket_history">
        <span @click.prevent="chat.ui.ticket_history = false" class="shadow-sm cursor_pointer text-secondary animated--grow-in bg-white py-2 px-3 mr-3">
          <span class=""><i class="bx bx-chevron-left mr-2"></i> {{ getTranslations('expression_113') }}</span>
        </span>
      </div>
      <div>
        <span data-dismiss="modal" class="shadow-sm cursor_pointer animated--grow-in btn-secondary text-white py-2 px-3">
          <span class="">{{ getTranslations('expression_340') }}</span>
        </span>
      </div>
    </div>
  </ModalDefault>
</template>

<script>
import ModalDefault from "../../components/general/ModalDefault";
import {mapGetters, mapState} from "vuex";
import $ from "jquery";
import ChatBalloonDefault from "../../components/chat/ChatBalloonDefault";
import Pagination from "../../components/theme/Pagination";

export default {
  name: "ModalChatHistoryTicket",
  components: {
    ModalDefault,
    ChatBalloonDefault,
    Pagination
  },
  data() {
    return {
    }
  },
  computed: {
    ...mapState(['chat', 'me', 'operators']),
    ...mapGetters([
      'getUserObject',
      'getChannelObject',
      'getDepartmentObject',
      'getOperatorObject',
    ])
  },
  mounted() {
    this.$root.$on('clearTransfer',()=> {
      this.ticket_transfer = {
        operator_id: null,
        department_id: null
      }
    })
    $('#historyTicketModal').on('hidden.bs.modal', () => {
      this.chat.old_histories = []
      this.chat.old_tickets = []
      this.chat.ui.ticket_history = false
    })
  },
  methods: {
    showOldHistories(payload){
      this.chat.old_histories = []
      this.$store.dispatch('getOldHistories', {
        ticket_id: payload.id
      })
    },
    showHistories(payload){
      this.tickets.histories_followup_ticket = [];
      // this.$store.dispatch('getHistories', {ticket_id: payload.id})
      // this.tickets.ticket = payload
      this.ticket_view = 1;
      this.$store.commit('SET_TICKET', payload);
      this.$store.dispatch('getLeadTags', {lead_id: payload.lead_id})
      this.$store.dispatch('getTicketStatuses', {ticket_id: payload.id})
      setTimeout(() => {
        document.getElementById('chat_conversation').scrollIntoView({block: "end", behavior: "smooth"});
        this.$root.$emit('bv::hide::tooltip')
        // this.$root.$emit('bv::disable::tooltip')
      }, 500);
    },
  }
}
</script>

<style scoped>

</style>
